<template>
    <div class="relative aspect-2/1 w-full">
        <img
            class="h-full w-full scale-150 rotate-[30deg] object-contain"
            :src="images[setup - 1] ?? images[0]"
            :alt="$t('setup_card.dart_image_alt', { n: setup })"
        />
    </div>
</template>

<script>
export default {
    name: 'SetupImage',
    props: {
        setup: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    data() {
        return {
            images: [
                new URL('@/assets/images/setups/dart1.png', import.meta.url).href,
                new URL('@/assets/images/setups/dart2.png', import.meta.url).href,
                new URL('@/assets/images/setups/dart3.png', import.meta.url).href,
                new URL('@/assets/images/setups/dart4.png', import.meta.url).href,
                new URL('@/assets/images/setups/dart5.png', import.meta.url).href,
            ],
        }
    },
}
</script>
